import classNames from 'classnames'

export default ({ className, children, title }) => (
  <div className={classNames('checkbox-group', className)}>
    {title ? <p className="mbm h6 text-bold">{title}</p> : null}
    {children}
  </div>
)
